import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';
import InputAdornment from '@material-ui/core/InputAdornment';
import {
  Search as SearchIcon,
  Close
} from '@material-ui/icons';

const styles = theme => ({
  root: {
    marginBottom: 20,
  },
  box: {
    padding: 15,
    background: '#edf0f4',
    borderRadius: 3

  },
  icon: {
    color: theme.palette.grey.main
  },
  iconPink: {
    color: theme.palette.secondary.contrast
  },
  right: {
    flex: 1,
    float: 'right'
  }
});

class Search extends Component {

  state = {
    open: false
  }

  open = () => this.setState({ open: true });

  close = () => this.setState({ open: false });

  handleChange = evt => {
    if (evt.target.value.length >= 1) {
      this.props.onUpdate(evt.target.value);
    } else {
      this.props.onUpdate('');
    }
  }

  render() {
    const { classes } = this.props;
    const { open } = this.state;

    return (
      <div className={classes.root}>
        { !open &&
          <Grid container alignItems="flex-end" justifyContent="flex-end">
            <Grid item className={classes.right}>
              <Fab size="medium" className={classes.right} color="secondary" onClick={this.open}>
                <SearchIcon className={classes.iconPink} />
              </Fab>
            </Grid>
          </Grid>
        }

        { open &&
          <div className={classes.box}>
            <Grid container alignItems="center" justifyContent="center">
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  placeholder="Search"
                  onChange={this.handleChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <SearchIcon className={classes.icon} />
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid item className={classes.right}>
                <IconButton className={classes.right} onClick={this.close}>
                  <Close className={classes.icon} />
                </IconButton>
              </Grid>
            </Grid>
          </div>
        }
      </div>
    )
  }
}

Search.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Search);
